import type { CSSProperties, ReactNode } from 'react';
import C2Shape from './Shape';
import type { PastelColor } from './Pill';

export interface DecorShape {
  shape: 'circle' | 'pill' | 'square';
  size: number;
  color: PastelColor;
  style?: CSSProperties;
}

interface C2SectionProps {
  children?: ReactNode;
  pad?: number;
  bg?: string;
  className?: string;
  style?: CSSProperties;
  decor?: DecorShape[];
}

export default function C2Section({ children, pad = 96, bg, className = '', style, decor }: C2SectionProps) {
  const hasDecor = !!decor && decor.length > 0;
  return (
    <section
      style={{
        padding: `${pad}px clamp(32px, 6vw, 96px)`,
        background: bg,
        ...(hasDecor ? { position: 'relative', overflow: 'hidden' } : null),
        ...style,
      }}
      className={className}
    >
      {hasDecor &&
        decor!.map((s, i) => (
          <C2Shape key={i} shape={s.shape} size={s.size} color={s.color} style={s.style} />
        ))}
      <div className={`max-w-[1280px] mx-auto ${hasDecor ? 'relative' : ''}`}>{children}</div>
    </section>
  );
}
